import { ChangeDetectionStrategy, Component } from '@angular/core';
import { combineLatest, timer } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { ClockService } from '../services/clock.service';
import { WeatherService } from '../services/weather.service';

const WEATHER_REFRESH_INTERVAL = 60000; // 1 minute

@Component({
    selector: 'app-clock-widget',
    templateUrl: './clock-widget.component.html',
    styleUrls: ['./clock-widget.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ClockWidgetComponent {

  constructor(private clockService: ClockService, private weatherService: WeatherService) { }

  private weather$ = timer(0, WEATHER_REFRESH_INTERVAL).pipe(
    switchMap(_ => this.weatherService.currentWeather$),
    map(w => ({
      tempMin: w.temperatureMin,
      tempMax: w.temperatureMax,
      weatherCode: w.weatherCode
    }))
  );

  vm$ = combineLatest(
    this.clockService.time,
    this.weather$
  )
  .pipe(
    map(([time, weather]) => ({
      time: time,
      weather: weather
    }))
  );

}
